




























































































import { LessonDTO } from "../../../src_server/entity/dto/LessonDTO";
import { Vue, Component, Prop } from "vue-property-decorator";
import { LessonStates } from "../../../src_server/entity/master/LessonStates";
import {
  dayjs,
  DTW_FORMAT_JA,
  T_FORMAT_JA,
} from "../../../src_server/common/momentExtends";
import { MessageDialog } from "../../utils/MessageDialog";
import { LessonsService } from "../../biz/remote/LessonsService";
import { routeHelper } from "../../utils/routeHelper";

@Component({
  components: {},
  filters: {
    dateFormat(date: Date) {
      return dayjs(date).format(DTW_FORMAT_JA);
    },
    dtFormat(date: Date) {
      return dayjs(date).format(T_FORMAT_JA);
    },
  },
})
export default class TeacherDashboardRow extends Vue {
  @Prop({ default: new LessonDTO() })
  private dto!: LessonDTO;

  get isAlready() {
    return this.dto.lessons.reservation_state === LessonStates.ALREADY;
  }

  get isTransfer() {
    return this.dto.lessons.reservation_state === LessonStates.TRANSFAR;
  }

  get isPast() {
    return dayjs(this.dto.lessons.start_dt).diff(dayjs()) < 0;
  }

  gotoDailyReport(row: LessonDTO) {
    if(dayjs(row.lessons.start_dt).diff(dayjs()) > 0){
      MessageDialog.alert("授業開始前に日報を作成できません。");
      return;
    }
    this.$emit("goto-daily-report", row);
  }
  message(row: LessonDTO) {
    this.$emit("message", row);
  }
  transfer(row: LessonDTO) {
    this.$emit("transfer", row);
  }
  showPersonalPlan(row: LessonDTO) {
    const student_user_id = row.student?.user_id;
    routeHelper(this, "SupportPlanPageFroTeacher", { user_id: student_user_id });
  }

  // async commentChange() {
  //   if (!this.dto.lessons.class_id) {
  //     MessageDialog.systemError('レッスンID', '一言コメント送信時');
  //     return;
  //   }
  //   if (!this.dto.lessons.one_comment) {
  //     MessageDialog.systemError('コメント', '一言コメント送信時');
  //     return;
  //   }
  //   console.log('comment ');
  //   const biz = new LessonsService();
  //   await biz.updateOneComment(this.dto.lessons.class_id, this.dto.lessons.one_comment);
  //   await MessageDialog.alert('コメントを更新しました');
  // }
}
